// extracted by mini-css-extract-plugin
export default {"container":"itemComp_container__mXEXh","rightBox":"itemComp_rightBox__Cr294"};